module.exports = __webpack_public_path__ + "static/media/icon_clock.823bb0d2.png";